import Pagination from "@mui/material/Pagination";
import { useState } from "react";
import "./paginator.scss";
import { useSelector } from "react-redux";

const Paginator = ({ size = 5, table = null, colspan = 5, children = [], change = null, page = null, totalCount = null }) => {

  const dir = useSelector(({ theme }) => theme.direction);

  const [currentPage, setCurrentPage] = useState(1);
  const onPaginationChange = (event, value) => {
    setCurrentPage(value);
  };
  const RenderPagination = () => {
    let arr = [];
    let stopAt = currentPage * size;
    let startAt = stopAt - size;
    for (let index = startAt; index < stopAt; index++) {
      arr.push(children[index]);
    }

    return arr;
  };
  return table ? (
    <>
      <RenderPagination />
      <tr>
        <td colSpan={colspan}>
          <Pagination
            color="primary"
            count={totalCount ? Math.ceil(totalCount / size) : Math.ceil(children.length / size)}
            onChange={change ? change : onPaginationChange}
            page={page ? page : currentPage}
            className={`${dir === 'rtl' && 'paginate-rtl'} table-pagination`}
            sx={{
              "& .MuiPagination-ul": {
                justifyContent: "center",
                direction: {dir},
                // mt: "2rem",
                // mb: "2rem",
                width: "100%",
                padding: 0,
              },
            }}
          />
        </td>
      </tr>
      
    </>
  ) : (
    <>
      <RenderPagination />
      <Pagination
        color="primary"
        count={totalCount ? Math.ceil(totalCount / size) : Math.ceil(children.length / size)}
        onChange={change ? change : onPaginationChange}
        page={page ? page : currentPage}
        className={`${dir === 'rtl' && 'paginate-rtl'}`}
        sx={{
          "& .MuiPagination-ul": {
            justifyContent: "center",
            direction: {dir},
            mt: "2rem",
          },
        }}
      />
    </>
  );
};

export default Paginator;
